import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.scss';
import App from './App';
import {AppDataProvider} from "./AppContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AppDataProvider>
        <Suspense fallback="loading">
            <App />
        </Suspense>
    </AppDataProvider>
);
